import React from 'react'

export const Inspections = () => {
  return (
    <div>Inspections</div>
  )
}
